module.exports = __webpack_public_path__ + "img/ctrl-circuit-stub-up-+.ef58ac36.svg";